export const getNameInitials = (firstName: string | undefined, lastName: string | undefined) => {
  return `${firstName?.slice(0, 1).toUpperCase()}${lastName?.slice(0, 1).toUpperCase()}`;
};

/** Temp function for thumbnails for employees/users till we have photos from etrack */
export const getMockThumbnailUrl = (): string => {
  let genderArr = ['men', 'women'];
  let randomNumber = Math.floor(Math.random() * genderArr.length);
  let which = Math.floor(Math.random() * 99);
  return `https://randomuser.me/api/portraits/thumb/${genderArr[randomNumber]}/${which}.jpg`;
};
